import YourShifts from '../pages/crew/YourShifts.jsx'
import YourAvailability from '../pages/crew/YourAvailability.jsx'
import YourPay from '../pages/crew/YourPay.jsx'
import YourTrainingAndDevelopment from '../pages/crew/YourTrainingAndDevelopment.jsx'
import DailyCrewTools from '../pages/crew/DailyCrewTools.jsx'
import ReadingAndAcknowledging from '../pages/crew/ReadingAndAcknowledging.jsx'

export default [
  {
    id: 'your-shifts',
    title: 'Your Shifts',
    summary:
      'Finding and applying for open work on Available Shifts, your confirmed shifts and applications on My Shifts, acknowledging a shift or saying you cannot attend, swap requests, shift reminders, putting shifts in your own calendar, and clocking in and out.',
    component: YourShifts,
    tags: [
      'Shifts',
      'Available Shifts',
      'My Shifts',
      'Apply',
      'Acknowledge',
      'Cannot Attend',
      'Swap',
      'Calendar Feed',
      'Clock In',
      'Clock Out',
    ],
  },
  {
    id: 'your-availability',
    title: 'Your Availability',
    summary:
      'Telling planners when you can work with Available windows, requesting annual leave and recording sickness, your holiday balance, and cancelling a record — and why availability never books you onto anything.',
    component: YourAvailability,
    tags: [
      'Availability',
      'My Availability',
      'Annual Leave',
      'Sickness',
      'Holiday Balance',
      'Time Off',
    ],
  },
  {
    id: 'your-pay',
    title: 'Your Pay',
    summary:
      'My Pay for both worker types: pay statements and pending-pay estimates with overtime, bonuses, and paid travel; overtime and expense claims; and, for invoice workers, generating or uploading pay invoices, the exact-amount rule, VAT, and what each invoice status means.',
    component: YourPay,
    tags: [
      'Pay',
      'My Pay',
      'Statements',
      'Pending Pay',
      'Overtime',
      'Expenses',
      'Invoice',
      'Self-Billing',
      'VAT',
      'Verified',
      'Paid',
    ],
  },
  {
    id: 'your-training-and-development',
    title: 'Your Training & Development',
    summary:
      'Staying in date on My Training — e-learning, the 80% pass mark, retakes, certificates, and expiry reminders — plus your appraisal steps, occupational health screenings, and reading the feedback on My Audits.',
    component: YourTrainingAndDevelopment,
    tags: [
      'Training',
      'My Training',
      'E-learning',
      'Mandatory Training',
      'Appraisals',
      'Occupational Health',
      'My Audits',
      'DOPS',
    ],
  },
  {
    id: 'daily-crew-tools',
    title: 'Daily Crew Tools',
    summary:
      'The crew day in AmbuNet: the start-of-shift check, VDIs, vehicle cleans, recording fuel, reporting defects, checking your meds bag and drawn-up medicines, and reporting incidents or raising a Speak Up concern.',
    component: DailyCrewTools,
    tags: [
      'Start of Shift',
      'VDI',
      'Vehicle Clean',
      'Fuel',
      'Defects',
      'Meds Bag',
      'Drawn-up Medicines',
      'Incidents',
      'Speak Up',
      'Quick Links',
    ],
  },
  {
    id: 'reading-and-acknowledging',
    title: 'Reading & Acknowledging',
    summary:
      'What you are asked to read and confirm: acknowledging announcements, unread Crew Vault items, marking policies and SOPs as read (policies must be opened first), signing PGDs with your password, and how safety alerts reach you.',
    component: ReadingAndAcknowledging,
    tags: [
      'Announcements',
      'Crew Vault',
      'Policies',
      'SOPs',
      'PGDs',
      'Sign',
      'Mark as Read',
      'Safety Alerts',
      'Acknowledge',
    ],
  },
]
